import { Data } from 'interfaces/ApolloResponse.interface'

export default ({
  common: { purpose, amount },
  system: { affiliateId }
}: Data) =>
  !(
    affiliateId === 200 &&
    ((purpose === 'RENOVATION' && amount > 120000) ||
      (purpose === 'REAL_ESTATE_FINANCING' && amount > 100000))
  )
